<template>
  <div>
    <GChart :settings="{ packages: ['corechart', 'controls'] }" style="display: none" type="LineChart" @ready="onChartReady" />
    <div id="chart-container" class="row no-gutters">
      <div id="cp-by-winners-chart" class="by-winners col-12">
        <div id="cp-by-winners-title-and-chart" class="title-and-chart no-gutters">
          <div class="title-and-chart-left">
            <div class="chart-title-container" v-show="this.$parent.getDisplayView() && getDisplayView()">
              <h4 class="text-primary">
                Winners Map
                <smart-center-link page="Profiles" location="Winners Map" />
              </h4>
            </div>
            <chart-legend
              :include-number-of-responses="true"
              :class="getLegendClass('pt-4 pb-3')"
              height="auto"
              :direction="'vertical'"
              :width="'auto'"
              location="Profile By Winners"
              :elements="$parent.legendElements"
              :container-id="'cp-by-winners-chart'"
              :show-number-of-responses="this.$parent.chartDisplayOptions.showNumberOfResponses"
              @redraw="showOrHideElements"
            >
            </chart-legend>
          </div>
          <div class="buttons-and-chart">
            <chart-buttons
              :display="this.$parent.getDisplayView() && getDisplayView()"
              :tooltip-configuration="snapChartTooltipConfig"
              :container-id="'cp-by-winners-chart'"
              :snap-container-id="'cp-by-winners-title-and-chart'"
              :container-class="'text-left'"
              :report-page-type-name="'Chart - Winners Map'"
              :insight-modal-id="'profile-by-winners-chart'"
              :text-direction="this.textDirection"
            >
            </chart-buttons>
            <div class="d-flex">
              <div class="winners-conserve-efforts">
                <div v-show="this.$parent.getDisplayView() && getDisplayView() && displayConserveChart" class="chart-header">
                  <base-header v-show="this.$parent.getDisplayView() && getDisplayView()" header-label="Table Stakes" />
                </div>
                <div id="winners_conserve_effort_chart" class="chart"></div>
              </div>
              <div class="winners-core-efforts">
                <div v-show="this.$parent.getDisplayView() && getDisplayView() && displayCoreChart" class="chart-header">
                  <base-header v-show="this.$parent.getDisplayView() && getDisplayView()" header-label="Core Strengths" />
                </div>
                <div id="winners_core_effort_chart" class="chart"></div>
              </div>
              <div class="winners-diverge-efforts">
                <div v-show="this.$parent.getDisplayView() && getDisplayView() && displayDivergeChart" class="chart-header">
                  <base-header v-show="this.$parent.getDisplayView() && getDisplayView()" header-label="Diverge & Dominate" />
                </div>
                <div id="winners_diverge_effort_chart" class="chart"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="by-winners col-12">
        <div v-show="this.$parent.getDisplayView() && getDisplayView()" :id="winnersMapTable.tableContainerId" class="chart-data">
          <chart-data-table
            ref="winnersDataTable"
            v-show="this.$parent.getDisplayView() && getDisplayView()"
            :chart-data="this.winnersMapTable.data"
            :display-direction="'vertical'"
            :data-container-id="winnersMapTable.tableContainerId"
            :container-id="'winners_conserve_effort_chart'"
            :column-defs="this.chart.columnDefs"
            :table-class="'table display row-border table-hover'"
            :table-width="'auto'"
            :report-page-type-name="'Table - Winners Map'"
            :insight-modal-id="'profile-by-winners-table'"
            :table-title="this.winnersMapTable.title"
          ></chart-data-table>
        </div>
      </div>
    </div>
    <div v-for="(pageContent, idxPageContent) in pageContentForWinners" v-bind:key="idxPageContent">
      <modal :modal-id="pageContent.title" :modal-title="pageContent.title" :modal-content="pageContent.contentText" />
    </div>
    <insights
      ref="insightsChart"
      :modal-name="'profile-by-winners-chart'"
      :report-page-type-name="'Chart - Winners Map'"
      :entry-page-content="this.pageContentForReport"
      @saveReportPage="$parent.updateReportPages"
      @saveAllReportPages="saveAllReportPages"
      @saveClientChart="$parent.saveClientChart"
    />
    <insights
      ref="insightsTable"
      :modal-name="'profile-by-winners-table'"
      :report-page-type-name="'Table - Winners Map'"
      :entry-page-content="this.pageContentForReport"
      @saveReportPage="$parent.updateReportPages"
      @saveAllReportPages="saveAllReportPages"
      @saveClientChart="$parent.saveClientChart"
    />
  </div>
</template>
<script>
import $ from "jquery";
import ChartLegend from "../../../components/chart/ChartLegend.vue";
import ChartButtons from "../../../components/chart/ChartButtons.vue";
import BaseHeader from "../../../templates/BaseHeader.vue";
import ChartCompanyMixins from "../../../mixins/ChartCompanyMixins.vue";
import ChartService from "../../../services/chart.service";
import ErrorService from "../../../services/error.service";
import AdminService from "../../../services/admin.service";
import NeedsService from "../../../services/needs.service";
import TableService from "../../../services/table.service";
import ReportService from "../../../services/report.service";
import ContentService from "../../../services/content.service";

export default {
  name: "ByWinners",
  mixins: [ChartCompanyMixins],
  components: { ChartLegend, ChartButtons, BaseHeader },
  data() {
    return {
      pageContentForWinners: [],
      barList: [],
      needsList: [],
      winnersConserveEffortChart: {},
      winnersCoreEffortChart: {},
      winnersDivergeEffortChart: {},

      winnersConserveEffortChartOptions: {},
      winnersCoreEffortChartOptions: {},
      winnersDivergeEffortChartOptions: {},

      winnersConserveEffortData: {},
      winnersCoreEffortData: {},
      winnersDivergeEffortData: {},
      displayConserveChart: true,
      displayCoreChart: true,
      displayDivergeChart: true,

      winnersMapTable: {
        id: "",
        data: {},
        tableContainerId: "winner_needs_data_container",
        title: '<h4 class="text-primary">Winners Map</h4>'
      },
      isMobile: false,
      itemsToRemove: {
        lastColumns: 2,
        firstColumns: 1
      },
      redrawAdditionalWidgets: true,
      textDirection: "horizontal"
    };
  },
  props: {
    chartData: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  computed: {},
  mounted() {
    let vm = this;
    $(window).smartresize(function() {
      if (vm.$parent.isByWinners) {
        vm.smartRedrawChart($("#winners_conserve_effort_chart"));
        vm.smartRedrawChart($("#winners_core_effort_chart"));
        vm.smartRedrawChart($("#winners_diverge_effort_chart"));
      }
    });
  },
  created() {
    ContentService.getPageContent("Winners", this.getPageContentByWinnersCallBack, this);    
  },
  methods: {
    getPageContentByWinnersCallBack(response) {
      let statusCode = response.data.statusCode;
      if (statusCode == 200) {
        this.pageContentForWinners = response.data.data;
      }
    },    
    displayInsights(insightModalId, reportPageTypeName) {
      if (reportPageTypeName == "Chart - Winners Map") {
        this.$refs.insightsChart.reportPageInput = ReportService.getReportPage(reportPageTypeName, this.$parent.reportPagesList);
        this.$refs.insightsChart.initializeInsights(this.$parent.clientChart);
        this.$modal.show(insightModalId);
      } else if (reportPageTypeName == "Table - Winners Map") {
        this.$refs.insightsTable.reportPageInput = ReportService.getReportPage(reportPageTypeName, this.$parent.reportPagesList);
        this.$refs.insightsTable.initializeInsights(this.$parent.clientChart);
        this.$modal.show(insightModalId);
      }
    },

    onChartReady(chart, google) {
      this.chartsLib = google;
      this.winnersConserveEffortChart = new google.visualization.ChartWrapper({
        chartType: "ComboChart",
        containerId: "winners_conserve_effort_chart"
      });
      this.winnersCoreEffortChart = new google.visualization.ChartWrapper({
        chartType: "ComboChart",
        containerId: "winners_core_effort_chart"
      });
      this.winnersDivergeEffortChart = new google.visualization.ChartWrapper({
        chartType: "ComboChart",
        containerId: "winners_diverge_effort_chart"
      });
    },
    setChartWidth() {
      let conserveOtherData = this.winnersConserveEffortData["otherData"];
      let maxWidthConserve = conserveOtherData["maxChartWidth"];
      $(".winners-conserve-efforts").css("width", maxWidthConserve);
      $(".winners-conserve-efforts").css("maxWidth", maxWidthConserve);

      let coreOtherData = this.winnersCoreEffortData["otherData"];
      let maxWidthCore = coreOtherData["maxChartWidth"];
      $(".winners-core-efforts").css("width", maxWidthCore);
      $(".winners-core-efforts").css("maxWidth", maxWidthCore);

      let divergeOtherData = this.winnersDivergeEffortData["otherData"];
      let maxWidthDiverge = divergeOtherData["maxChartWidth"];
      $(".winners-diverge-efforts").css("maxWidth", maxWidthDiverge);
      $(".winners-diverge-efforts").css("width", maxWidthDiverge);
    },
    async processChartData() {
      try {
        this.$parent.resetChartDisplayOptions();
        if (this.$parent.$refs.chartCriteria.$data.textDirection != ""){
          this.textDirection = this.$parent.$refs.chartCriteria.$data.textDirection;
        }
        this.chart = ChartService.getChartAttributes("Profile By Winners");
        this.$parent.pageContent.push(...this.pageContent);
        let needsData = JSON.parse(JSON.stringify(this.chartData[0]));
        let otherData = needsData["otherData"];
        this.$parent.legendElements = otherData["legend"];

        let moatsList = otherData["moatsList"];
        this.barList = otherData["barList"];
        this.needsList = otherData["needsList"];
        let companyColorList = otherData["companyColorList"];
        TableService.setCompanyColorList(companyColorList);
        ChartService.setMainClientXStyle(companyColorList[0].color, $("#chart-container"));

        let dynamicChartOptions = needsData["options"];
        let containerId = needsData["containerId"];
        let chartOptions = ChartService.getChartOptions(containerId);
        $.extend(chartOptions, dynamicChartOptions);
        if (this.$parent.showPricingPower) {
          this.itemsToRemove.lastColumns = 1;
        } else {
          this.itemsToRemove.lastColumns = 2;
        }
        chartOptions = this.setPricingPowerSeries(otherData, chartOptions, this.$parent.showPricingPower);
        this.winnersConserveEffortData = this.drawSingleEmotionalNeedsName(JSON.parse(JSON.stringify(this.chartData[0])));
        this.winnersConserveEffortChartOptions = JSON.parse(JSON.stringify(chartOptions));
        $.extend(this.winnersConserveEffortChartOptions, this.winnersConserveEffortData["options"]);
        this.winnersConserveEffortChartOptions = this.setPricingPowerSeries(otherData, this.winnersConserveEffortChartOptions, this.$parent.showPricingPower);
        $.extend(this.winnersConserveEffortChartOptions.vAxes[1], ChartService.getPricingPowerVAxis());
        this.winnersConserveEffortChartOptions = ChartService.setHAxisFormat(this.textDirection, this.winnersConserveEffortChartOptions);

        let chartContainerWidth = $("#" + containerId).width();
        if (chartContainerWidth < ChartService.getMobileBreakpoint()) {
          this.isMobile = true;
        } else {
          this.isMobile = false;
        }

        this.table.id = containerId;

        NeedsService.setFunctionalNeedsList(this.needsList);
        NeedsService.setEmotionalNeedsList(this.needsList);
        NeedsService.setMoatsList(moatsList);
        let copyOfChartData = JSON.parse(JSON.stringify(needsData));
        this.winnersCoreEffortData = this.drawSingleEmotionalNeedsName(JSON.parse(JSON.stringify(this.chartData[1])));
        this.winnersCoreEffortChartOptions = ChartService.getChartOptions(this.winnersCoreEffortData["containerId"]);
        $.extend(this.winnersCoreEffortChartOptions, this.winnersCoreEffortData["options"]);
        this.winnersCoreEffortChartOptions = this.setPricingPowerSeries(otherData, this.winnersCoreEffortChartOptions, this.$parent.showPricingPower);
        $.extend(this.winnersCoreEffortChartOptions.vAxes[1], ChartService.getPricingPowerVAxis());
        this.winnersCoreEffortChartOptions = ChartService.setHAxisFormat(this.textDirection, this.winnersCoreEffortChartOptions);

        this.winnersDivergeEffortData = this.drawSingleEmotionalNeedsName(JSON.parse(JSON.stringify(this.chartData[2])));
        this.winnersDivergeEffortChartOptions = ChartService.getChartOptions(this.winnersDivergeEffortData["containerId"]);
        $.extend(this.winnersDivergeEffortChartOptions, this.winnersDivergeEffortData["options"]);
        this.winnersDivergeEffortChartOptions = this.setPricingPowerSeries(otherData, this.winnersDivergeEffortChartOptions, this.$parent.showPricingPower);
        $.extend(this.winnersDivergeEffortChartOptions.vAxes[1], ChartService.getPricingPowerVAxis());
        this.winnersDivergeEffortChartOptions = ChartService.setHAxisFormat(this.textDirection, this.winnersDivergeEffortChartOptions);


        if (otherData["pricingPowerViewWindowMax"] != "undefined") {
          $.extend(this.winnersConserveEffortChartOptions.vAxes[1], { viewWindow: { max: otherData["pricingPowerViewWindowMax"] } });
          $.extend(this.winnersCoreEffortChartOptions.vAxes[1], { viewWindow: { max: otherData["pricingPowerViewWindowMax"] } });
          $.extend(this.winnersDivergeEffortChartOptions.vAxes[1], { viewWindow: { max: otherData["pricingPowerViewWindowMax"] } });
        }


        let originalWinnersCoreData = JSON.parse(JSON.stringify(this.chartData[1]));
        copyOfChartData.rows.push(...originalWinnersCoreData.rows);
        let originalWinnersDivergeData = JSON.parse(JSON.stringify(this.chartData[2]));
        copyOfChartData.rows.push(...originalWinnersDivergeData.rows);

        this.$parent.setChartResults(needsData.companyList);
        this.$parent.$data.criteriaResultsList = AdminService.removeByName(needsData.criteriaList, "Competitor");

        this.winnersConserveEffortData = this.drawSingleEmotionalNeedsName(needsData);
        if (this.$parent.$refs.chartCriteria.$data.showCompetitorExpectations == "Y") {
          this.$parent.processBarList(this.winnersConserveEffortChartOptions, this.barList);
          this.$parent.processBarList(this.winnersCoreEffortChartOptions, this.barList);
          this.$parent.processBarList(this.winnersDivergeEffortChartOptions, this.barList);
        }
        this.winnersMapTable.id = containerId;
        this.winnersMapTable.data = copyOfChartData;

        this.displayConserveChart = this.winnersConserveEffortData["otherData"]["displayChart"];
        this.displayCoreChart = this.winnersCoreEffortData["otherData"]["displayChart"];
        this.displayDivergeChart = this.winnersDivergeEffortData["otherData"]["displayChart"];
        this.setChartWidth();
        this.setWinnersMapChartOptions();

        if (this.displayConserveChart) {
          this.paintChart(
            this.$data.winnersConserveEffortChart,
            this.winnersConserveEffortData["containerId"],
            this.winnersConserveEffortChartOptions,
            this.winnersConserveEffortData,
            this.itemsToRemove.lastColumns,
            this.itemsToRemove.firstColumns
          );
        }
        if (this.displayCoreChart) {
          this.paintChart(
            this.$data.winnersCoreEffortChart,
            this.winnersCoreEffortData["containerId"],
            this.winnersCoreEffortChartOptions,
            this.winnersCoreEffortData,
            this.itemsToRemove.lastColumns,
            this.itemsToRemove.firstColumns
          );
        }
        if (this.displayDivergeChart) {
          this.paintChart(
            this.$data.winnersDivergeEffortChart,
            this.winnersDivergeEffortData["containerId"],
            this.winnersDivergeEffortChartOptions,
            this.winnersDivergeEffortData,
            this.itemsToRemove.lastColumns,
            this.itemsToRemove.firstColumns
          );
        }

        this.resetLegendElements();
        this.$root.$emit("check-number-of-responses");
        this.setDisplayView(true);
        this.$parent.setDisplayView(true);
      } catch (err) {
        ErrorService.processException("ByWinners.displayChartCallback", err, "chart", this);
      }
    },
    async showOrHideElements(element) {
      if (this.$parent.$refs.chartCriteria.$data.showCompetitorExpectations == "N" || !element.elementId.includes("bar")) {
        this.winnersConserveEffortChartOptions.series[element.seriesNumber].pointsVisible = element.visible;
        this.winnersCoreEffortChartOptions.series[element.seriesNumber].pointsVisible = element.visible;
        this.winnersDivergeEffortChartOptions.series[element.seriesNumber].pointsVisible = element.visible;
      }
      this.$parent.chartDisplayOptions.redrawAdditionalWidgets = false;
      let elementId = element.elementId;
      if (element.visible == true) {
        if (elementId.includes("blueX")) {
          this.$parent.chartDisplayOptions.paintBlueX = true;
        }
      }
      if (element.visible == false) {
        if (element.elementId == "thick") {
          this.winnersCoreEffortChartOptions.series[element.seriesNumber].type = "line";
          this.winnersCoreEffortChartOptions.series[element.seriesNumber].pointSize = 0;
          this.winnersConserveEffortChartOptions.series[element.seriesNumber].type = "line";
          this.winnersConserveEffortChartOptions.series[element.seriesNumber].pointSize = 0;
          this.winnersDivergeEffortChartOptions.series[element.seriesNumber].type = "line";
          this.winnersDivergeEffortChartOptions.series[element.seriesNumber].pointSize = 0;
        }
      } else {
        if (element.elementId == "thick") {
          this.winnersCoreEffortChartOptions.series[element.seriesNumber].type = "bars";
          this.winnersConserveEffortChartOptions.series[element.seriesNumber].type = "bars";
          this.winnersDivergeEffortChartOptions.series[element.seriesNumber].type = "bars";
        }
      }
      this.winnersConserveEffortData = this.drawSingleEmotionalNeedsName(JSON.parse(JSON.stringify(this.chartData[0])));
      this.$parent.showOrHideElements(element, $("#" + this.winnersConserveEffortData["containerId"]));
      if (this.displayConserveChart) {
        this.paintChart(
          this.$data.winnersConserveEffortChart,
          this.winnersConserveEffortData["containerId"],
          this.winnersConserveEffortChartOptions,
          this.winnersConserveEffortData,
          this.itemsToRemove.lastColumns,
          this.itemsToRemove.firstColumns
        );
      }
      this.winnersCoreEffortData = this.drawSingleEmotionalNeedsName(JSON.parse(JSON.stringify(this.chartData[1])));
      this.$parent.showOrHideElements(element, $("#" + this.winnersCoreEffortData["containerId"]));
      if (this.displayCoreChart) {
        this.paintChart(
          this.$data.winnersCoreEffortChart,
          this.winnersCoreEffortData["containerId"],
          this.winnersCoreEffortChartOptions,
          this.winnersCoreEffortData,
          this.itemsToRemove.lastColumns,
          this.itemsToRemove.firstColumns
        );
      }
      this.winnersDivergeEffortData = this.drawSingleEmotionalNeedsName(JSON.parse(JSON.stringify(this.chartData[2])));
      this.$parent.showOrHideElements(element, $("#" + this.winnersDivergeEffortData["containerId"]));
      if (this.displayDivergeChart) {
        this.paintChart(
          this.$data.winnersDivergeEffortChart,
          this.winnersDivergeEffortData["containerId"],
          this.winnersDivergeEffortChartOptions,
          this.winnersDivergeEffortData,
          this.itemsToRemove.lastColumns,
          this.itemsToRemove.firstColumns
        );
      }
    },
    async smartRedrawChart(generatedChart) {
      generatedChart.find(".blueX").remove();
      generatedChart.find(".bar").remove();
      generatedChart.find(".horizontal-line").remove();
      generatedChart.find(".vertical-line").remove();
      generatedChart.find(".vertical-dotted-line").remove();
      generatedChart.find(".winners-vertical-line").remove();
      generatedChart.find(".winners-vertical-line-light").remove();
      this.prePaintChart(true);
    },
    async prePaintChart(redrawWidgets, containerId) {
      this.redrawAdditionalWidgets = redrawWidgets;
      this.winnersConserveEffortData = this.drawSingleEmotionalNeedsName(JSON.parse(JSON.stringify(this.chartData[0])));
      if (this.displayConserveChart) {
        this.paintChart(
          this.$data.winnersConserveEffortChart,
          this.winnersConserveEffortData["containerId"],
          this.winnersConserveEffortChartOptions,
          this.winnersConserveEffortData,
          this.itemsToRemove.lastColumns,
          this.itemsToRemove.firstColumns
        );
      }
      this.winnersCoreEffortData = this.drawSingleEmotionalNeedsName(JSON.parse(JSON.stringify(this.chartData[1])));
      if (this.displayCoreChart) {
        this.paintChart(
          this.$data.winnersCoreEffortChart,
          this.winnersCoreEffortData["containerId"],
          this.winnersCoreEffortChartOptions,
          this.winnersCoreEffortData,
          this.itemsToRemove.lastColumns,
          this.itemsToRemove.firstColumns
        );
      }
      this.winnersDivergeEffortData = this.drawSingleEmotionalNeedsName(JSON.parse(JSON.stringify(this.chartData[2])));
      if (this.displayDivergeChart) {
        this.paintChart(
          this.$data.winnersDivergeEffortChart,
          this.winnersDivergeEffortData["containerId"],
          this.winnersDivergeEffortChartOptions,
          this.winnersDivergeEffortData,
          this.itemsToRemove.lastColumns,
          this.itemsToRemove.firstColumns
        );
      }
    },
    setShowNumberOfResponses(value){
      this.$parent.chartDisplayOptions.showNumberOfResponses = value;
    },
    async setXAxisTextDirection(containerId, direction){
      if (typeof this.$parent.$refs.chartCriteria != "undefined"){
          this.$parent.$refs.chartCriteria.setTextDirection(direction);
      }      
      this.winnersConserveEffortChartOptions = ChartService.setHAxisFormat(direction, this.winnersConserveEffortChartOptions);
      this.winnersCoreEffortChartOptions = ChartService.setHAxisFormat(direction, this.winnersCoreEffortChartOptions);
      this.winnersDivergeEffortChartOptions = ChartService.setHAxisFormat(direction, this.winnersDivergeEffortChartOptions);
      this.textDirection = direction;
      this.prePaintChart(true);
    },
    postPaintChart(primary_chart, containerId, options, dataTable) {
      let chartContainer = $("#" + containerId);
      let chartInterface = primary_chart.getChartLayoutInterface();
      let parentContainer = chartContainer.parent();
      var chartHeader = parentContainer.find(".chart-header");
      let chartLegend = parentContainer.find(".chart-legend");
      let chartLegendLeft = chartInterface.getChartAreaBoundingBox().left + 1;
      chartLegend.css("position", "relative");
      chartLegend.css("left", chartLegendLeft + "px");

      let chartBase = {
        width: 0,
        left: 0,
        top: 6,
        height: chartInterface.getChartAreaBoundingBox().height
      };

      let blueX = {
        top: chartBase.top - 13,
        left: chartBase.left - 8
      };
      let baseGreenBar = {
        top: chartBase.top - 8,
        left: chartBase.left - 10
      };
      let columnIndex = 3;
      let yAxisIndex = 0;
      let headerWidth;
      for (let index = 0; index < dataTable.getNumberOfRows(); index++) {
        for (var barIndex = 0; barIndex < this.barList.length; barIndex++) {
          let currentBar = this.barList[barIndex];
          let value = dataTable.getValue(index, currentBar.index);
          if (!isNaN(value) && value > 0) {
            if (!this.$parent.skipPaintBar(currentBar.className, "functional")) {
              let barLeft = chartInterface.getXLocation(index) + baseGreenBar.left;
              let barTop = chartInterface.getYLocation(value, yAxisIndex) + baseGreenBar.top;
              chartContainer.append(ChartService.paintBar(barTop, barLeft, currentBar.className, currentBar.backgroundColor));
              let needName = dataTable.getValue(index, barIndex);
              if (this.isEmotionalNeed(needName)) {
                let nameTop = chartInterface.getYLocation(5.5, yAxisIndex) + baseGreenBar.top;
                chartContainer.append(ChartService.paintHorizontalLine(nameTop, barLeft - 5, 31, "dark-grey-horizontal-line emotional-needs-horizontal-line"));
              }
            }
          }
        }
        if (this.$parent.chartDisplayOptions.paintBlueX == true) {
          ChartService.paintDataPoints(options, chartInterface, dataTable, chartContainer, columnIndex, yAxisIndex, blueX.left, blueX.top);
        }
      }
      if (this.$parent.chartDisplayOptions.redrawAdditionalWidgets == true) {
        let header = parentContainer.find(".header-11");
        let finalheaderWidth = chartInterface.getChartAreaBoundingBox().left + headerWidth + 17;
        header.css("width", finalheaderWidth + "px");
        chartHeader.css("visibility", "visible");
        chartHeader.css("position", "relative");
        chartHeader.css("width", chartInterface.getChartAreaBoundingBox().width + 2 + "px");
        chartHeader.css("left", chartInterface.getChartAreaBoundingBox().left - 1 + "px"); //
        $("#" + containerId)
          .parent()
          .parent()
          .parent()
          .parent()
          .addClass("chart-wrapper");
      }
      if (this.displayDivergeChart && containerId == "winners_diverge_effort_chart") {
        parentContainer.parent().parent().find(".chart-button-container").css("left", "30px"); 
        this.saveReportPage("cp-by-winners-title-and-chart");
      } else if (!this.displayDivergeChart && this.displayCoreChart && containerId == "winners_core_effort_chart") {
        parentContainer.parent().parent().find(".chart-button-container").css("left", "30px"); 
        this.saveReportPage("cp-by-winners-title-and-chart");
      } else if (!this.displayDivergeChart && !this.displayCoreChart && this.displayConserveChart && containerId == "winners_conserve_effort_chart") {
        parentContainer.parent().parent().find(".chart-button-container").css("left", "30px"); 
        this.saveReportPage("cp-by-winners-title-and-chart");
      }
    },
    async saveReportPage(containerId) {
      if (this.$parent.clientChart.clientChartId != 0 && this.isGenerateReportRunning()) {
        let reportPageChart = $("#" + containerId);
        reportPageChart.find(".chart-header").css("display", "block");
        reportPageChart.find(".moat-header").css("display", "flex");
        reportPageChart.find(".chart-header").css("visibility", "visible");

        let reportPageChartObject = reportPageChart[ 0 ];
        let imageReportPageChartContent = await this.createChartImage(reportPageChartObject, false, true); 
        
        await ReportService.saveReportPage(imageReportPageChartContent, "Chart - Winners Map", this.$parent.clientChart, this.saveReportPageCallback, this);
        await ReportService.saveReportPageFile(this.imageUrl, "png", "Chart - Winners Map", this.$parent.clientChart, this.saveReportPageCallback, this);
/*        
        let tableContainerId = this.winnersMapTable.tableContainerId;
        let reportPageTableName = "Table - Winners Map";
        let imageReportPageTableContent = await this.createTableImage(this, tableContainerId, false, 750, 10); 
        await ReportService.saveReportPage(imageReportPageTableContent, reportPageTableName, this.$parent.clientChart, this.saveReportPageCallback, this);
        await ReportService.saveReportPageFile(this.tableImageUrl, "png", reportPageTableName, this.$parent.clientChart, this.saveReportPageFileCallback, this);
*/        
        await ReportService.saveReportTableFile(
          this.$refs.winnersDataTable.getTableData(),
          "Table - Winners Map",
          this.$parent.clientChart,
          this.saveReportTableFileCallback,
          this
        );
        await ReportService.saveReportPage(
          this.getReportTableContent("winners_conserve_effort_chart"),
          "Table - Winners Map",
          this.$parent.clientChart,
          this.saveReportPageCallback,
          this
        );
      }
    },
    saveAllReportPages() {
      this.saveReportPage("cp-by-winners-title-and-chart");
    },
    getLegendClass: function(legendClass) {
      if (this.$parent.getDisplayView() && this.getDisplayView()) {
        legendClass += " visible";
      } else {
        legendClass += " invisible";
      }
      return legendClass;
    }
  },
  watch: {
    chartData: function() {
      /* eslint no-empty: ["error", { "allowEmptyCatch": true }] */
      try{this.winnersConserveEffortChart.getChart().clearChart();} catch(e){}
      /* eslint no-empty: ["error", { "allowEmptyCatch": true }] */
      try{this.winnersCoreEffortChart.getChart().clearChart();} catch(e){}
      /* eslint no-empty: ["error", { "allowEmptyCatch": true }] */
      try{this.winnersDivergeEffortChart.getChart().clearChart();} catch(e){}

      if (this.$parent.isByWinners) {
        this.processChartData();
      } else {
        this.setDisplayView(false);
      }
    }
  }
};
</script>
